function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { useEffect, useState, useMemo } from 'react';
import { Tab } from 'react-bootstrap';
import { Bottom } from 'moduleBase/modules/menu/components/desktop/Bottom';
import { Tabs } from 'moduleBase/modules/menu/components/desktop/Tabs';
import { TabsContent } from 'moduleBase/modules/menu/components/desktop/TabsContent';
import { bindActionCreators } from 'redux';
import realtimeNotification from 'srcJs/components/realtime-notification/realtime-notification';
import { MESSAGE_TYPE_DEAL_STATUS_CHANGE, MESSAGE_TYPE_MENU_MAIN_UPDATE, MESSAGE_TYPE_PROJECT_DELETE } from 'srcJs/components/realtime-notification/constants/constants';
import { menuMainLoad } from 'moduleBase/modules/menu/actions/main-load';
import { LAYOUT_SMALL_COOKIE_KEY, REDUCER_MENU_NAME } from 'moduleBase/modules/menu/constants';
import SidebarArrow from 'images/sidebar-arrow.svg';
import LogoShortPrimaryWithSupport from 'images/logo-short-primary-with-support.svg';
import { connect } from '@collaborator/npm_modules/dist/components/redux';
import { NavLink } from 'components/router/NavLink';
import { useUserData } from 'components/user/hooks/use-user-data';
import Cookies from 'js-cookie';
import { menuMainLoadChannels, menuMainLoadProjects } from 'moduleBaseMenu/actions/load-sub-menu';

var DesktopNav = function DesktopNav(_ref) {
  var menu = _ref.menu,
      activeId = _ref.activeId,
      load = _ref.load,
      loadChannels = _ref.loadChannels,
      loadProjects = _ref.loadProjects;

  var _useState = useState(menu.activeBlock),
      _useState2 = _slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  var _useState3 = useState(Cookies.get(LAYOUT_SMALL_COOKIE_KEY) === undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setOpen = _useState4[1];

  var _useUserData = useUserData(),
      isOwner = _useUserData.isOwner;

  var defaultBottomData = useMemo(function () {
    var activeBlock = menu.blocks.find(function (block) {
      return block.id === activeTab;
    });
    return activeBlock.bottom;
  }, []);

  var handlerMenuMainUpdate = function handlerMenuMainUpdate() {
    load();
  };

  var handlerDealStatusChange = function handlerDealStatusChange() {
    loadChannels();
  };

  var handlerProjectDelete = function handlerProjectDelete() {
    loadProjects();
  };

  var open = function open() {
    setOpen(true);
    Cookies.remove(LAYOUT_SMALL_COOKIE_KEY);
  };

  var close = function close() {
    setOpen(false);
    Cookies.set(LAYOUT_SMALL_COOKIE_KEY, '1', {
      expires: 365
    });
  };

  var toggle = function toggle() {
    if (isOpen) {
      close();
    } else {
      open();
    }
  };

  var handlerTabsSelect = function handlerTabsSelect() {
    if (!isOpen) {
      open();
    }
  };

  useEffect(function () {
    realtimeNotification.addListener(MESSAGE_TYPE_MENU_MAIN_UPDATE, handlerMenuMainUpdate);

    if (isOwner) {
      realtimeNotification.addListener(MESSAGE_TYPE_DEAL_STATUS_CHANGE, handlerDealStatusChange);
    }

    realtimeNotification.addListener(MESSAGE_TYPE_PROJECT_DELETE, handlerProjectDelete);
    return function () {
      realtimeNotification.removeListener(handlerMenuMainUpdate);

      if (isOwner) {
        realtimeNotification.removeListener(handlerDealStatusChange);
      }

      realtimeNotification.removeListener(handlerProjectDelete);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "desktop-nav row flex-nowrap no-gutters d-none d-lg-flex ".concat(isOpen ? 'opened' : 'closed')
  }, /*#__PURE__*/React.createElement(Tab.Container, {
    id: "platform-tabs",
    activeKey: activeTab,
    onSelect: setActiveTab
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto d-flex flex-column align-items-center bg-light py-16p"
  }, /*#__PURE__*/React.createElement(NavLink, {
    to: "/",
    className: "desktop-nav__logo mb-4p"
  }, /*#__PURE__*/React.createElement("img", {
    src: LogoShortPrimaryWithSupport,
    className: "desktop-nav__logo-img"
  })), /*#__PURE__*/React.createElement(Tabs, {
    blocks: menu.blocks,
    onSelect: handlerTabsSelect,
    tools: menu.tools,
    faq: menu.faq
  }), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-secondary btn-square p-0 mt-auto",
    type: "button",
    onClick: toggle
  }, /*#__PURE__*/React.createElement("img", {
    src: SidebarArrow,
    className: "desktop-nav__toggle-icon"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "desktop-nav-menu col min-w-0 pt-16p px-16p d-flex flex-column custom-scroll"
  }, /*#__PURE__*/React.createElement(TabsContent, {
    blocks: menu.blocks,
    activeId: activeId,
    supportInfo: menu.supportInfo,
    tools: menu.tools,
    faq: menu.faq
  }), /*#__PURE__*/React.createElement(Bottom, {
    bottomData: defaultBottomData
  }))));
};

export default connect(DesktopNav, {
  mapStateToProps: function mapStateToProps(state) {
    return state[REDUCER_MENU_NAME];
  },
  mapDispatchToProps: function mapDispatchToProps(dispatch) {
    return bindActionCreators({
      load: menuMainLoad,
      loadChannels: menuMainLoadChannels,
      loadProjects: menuMainLoadProjects
    }, dispatch);
  }
});